import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

function HealthSafetyPolicy() {
  return (
    <>
      <Header />
      <main className="main" style={{ background: 'linear-gradient(135deg, #FDFCFE 0%, #FAF8FC 50%, #F5EBFA 100%)', minHeight: '100vh' }}>
        {/* Hero Section */}
        <section style={{
          background: 'linear-gradient(to bottom, rgba(15, 23, 42, 0.7) 0%, rgba(30, 41, 59, 0.8) 100%), url(/assets/img/dtk4.jpg)',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundAttachment: 'fixed',
          minHeight: '65vh',
          display: 'flex',
          alignItems: 'center',
          position: 'relative',
          overflow: 'hidden'
        }}>
          <div style={{
            content: '',
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundImage: 'url("data:image/svg+xml,%3Csvg xmlns=\'http://www.w3.org/2000/svg\' viewBox=\'0 0 100 100\' fill=\'rgba(255,255,255,0.03)\'%3E%3Ccircle cx=\'25\' cy=\'25\' r=\'1\'/%3E%3Ccircle cx=\'75\' cy=\'75\' r=\'1.5\'/%3E%3C/svg%3E")',
            backgroundSize: '80px 80px',
            backgroundRepeat: 'repeat',
            animation: 'float 20s ease-in-out infinite'
          }}></div>
          <div className="container" style={{ position: 'relative', zIndex: 2 }}>
            <div className="row">
              <div className="col-lg-10 mx-auto text-center">
                <div style={{
                  backgroundColor: 'rgba(123, 63, 158, 0.15)',
                  backdropFilter: 'blur(10px)',
                  borderRadius: '24px',
                  padding: '60px 50px 40px',
                  color: 'white'
                }}>
                  <h2 style={{ fontSize: '2.5rem', fontWeight: '700', marginBottom: '10px', textShadow: '0 2px 10px rgba(123, 63, 158, 0.97)', color: '#fff' }}>
                    DTK HEALTH AND SAFETY POLICY
                  </h2>
                  <p style={{ fontSize: '1.2rem', marginBottom: 0, opacity: 0.95 }}>
                    Ensuring a Safe Working and Learning Environment
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Policy Information Table */}
        <section style={{ padding: '80px 0 60px' }}>
          <div className="container" data-aos="fade-up">
            <div className="row justify-content-center">
              <div className="col-lg-10">
                <div className="shadow-lg" style={{
                  backgroundColor: '#fff',
                  borderRadius: '24px',
                  overflow: 'hidden',
                  border: '1px solid #e2e8f0'
                }}>
                  <div className="table-responsive">
                    <table className="table mb-0" style={{ fontSize: '1rem' }}>
                      <tbody>
                        <tr style={{ borderBottom: '1px solid #e2e8f0' }}>
                          <td style={{ padding: '20px 30px', fontWeight: '600', backgroundColor: '#f8fafc', width: '30%' }}>Lead Responsibility</td>
                          <td style={{ padding: '20px 30px' }}>Laurence T. Sofowora</td>
                          <td style={{ padding: '20px 30px', fontWeight: '600', backgroundColor: '#f8fafc', width: '25%' }}>Approved by</td>
                          <td style={{ padding: '20px 30px' }}>Adekunle Ayeni</td>
                        </tr>
                        <tr style={{ borderBottom: '1px solid #e2e8f0' }}>
                          <td style={{ padding: '20px 30px', fontWeight: '600', backgroundColor: '#f8fafc' }}>Version</td>
                          <td style={{ padding: '20px 30px' }}>V10 – 2025</td>
                          <td style={{ padding: '20px 30px', fontWeight: '600', backgroundColor: '#f8fafc' }}>Date of Approval</td>
                          <td style={{ padding: '20px 30px' }}>1/12/2025</td>
                        </tr>
                        <tr style={{ borderBottom: '1px solid #e2e8f0' }}>
                          <td style={{ padding: '20px 30px', fontWeight: '600', backgroundColor: '#f8fafc' }}>Effective from</td>
                          <td style={{ padding: '20px 30px' }}>1/12/2025</td>
                          <td style={{ padding: '20px 30px', fontWeight: '600', backgroundColor: '#f8fafc' }}>Next review date</td>
                          <td style={{ padding: '20px 30px' }}>1/12/2026</td>
                        </tr>
                        <tr style={{ borderBottom: '1px solid #e2e8f0' }}>
                          <td style={{ padding: '20px 30px', fontWeight: '600', backgroundColor: '#f8fafc' }}>Policy applicable to</td>
                          <td colSpan="3" style={{ padding: '20px 30px' }}><strong>ALL EMPLOYEES and FREELANCE STAFF</strong></td>
                        </tr>
                        <tr>
                          <td style={{ padding: '20px 30px', fontWeight: '600', backgroundColor: '#f8fafc' }}>Record of Changes:</td>
                          <td colSpan="3" style={{ padding: '20px 30px' }}>Reporting of Injuries, Diseases and Dangerous Occurrences Regulations Act date updated</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* 1. Introduction */}
        <section style={{ padding: '0 0 60px' }}>
          <div className="container" data-aos="fade-up">
            <div className="row justify-content-center">
              <div className="col-lg-10">
                <div className="p-5 shadow-lg" style={{ 
                  backgroundColor: '#fff',
                  borderRadius: '24px',
                  border: '1px solid #e2e8f0'
                }}>
                  <h3 style={{ color: '#0369a1', fontSize: '1.8rem', fontWeight: '700', marginBottom: '20px' }}>
                    1. INTRODUCTION
                  </h3>
                  
                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '20px' }}>
                    This Health and Safety Policy outlines the commitment of DTK to ensure positive management of health, safety and welfare risks that may be faced by staff, students, apprentices in their place of work, visitors, and all others on DTK premises.
                  </p>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '20px' }}>
                    The Policy explains how roles, responsibilities and accountabilities are delegated.
                  </p>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '20px' }}>
                    DTK believes health and safety has a vital role to play in the overall success of DTK and we must all adopt a positive attitude towards our safety, health, and welfare. We expect all staff to co-operate fully with DTK to enable us to meet our health and safety responsibilities.
                  </p>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '20px' }}>
                    This Policy is supported by separate guidance that explains the arrangements in specific risk areas for carrying out the Health and Safety Policy.
                  </p>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '0' }}>
                    The guide sets out the standards that staff are expected to meet.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* 2. Purpose and Scope */}
        <section style={{ padding: '0 0 60px' }}>
          <div className="container" data-aos="fade-up">
            <div className="row justify-content-center">
              <div className="col-lg-10">
                <div className="p-5 shadow-lg" style={{ 
                  backgroundColor: '#fff',
                  borderRadius: '24px',
                  border: '1px solid #e2e8f0'
                }}>
                  <h3 style={{ color: '#0369a1', fontSize: '1.8rem', fontWeight: '700', marginBottom: '20px' }}>
                    2. Purpose and Scope
                  </h3>
                  
                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '0' }}>
                    The Health and Safety at Work etc. Act 1974 places a duty on the employer to prepare and keep revised a written Health and Safety Statement, and to bring it to the notice of the employees and workers in the workplace. Accordingly, within this Policy (below) is DTK' Health and Safety Policy Statement. Where the term 'staff' is used in this Policy it should be taken to include all workers engaged in DTK' activities e.g. Freelance Assessors.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* 3. Health and Safety Statement */}
        <section style={{ padding: '0 0 60px' }}>
          <div className="container" data-aos="fade-up">
            <div className="row justify-content-center">
              <div className="col-lg-10">
                <div className="p-5 shadow-lg" style={{ 
                  backgroundColor: '#fff',
                  borderRadius: '24px',
                  border: '1px solid #e2e8f0'
                }}>
                  <h3 style={{ color: '#0369a1', fontSize: '1.8rem', fontWeight: '700', marginBottom: '20px' }}>
                    3. Health and Safety Statement
                  </h3>
                  
                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '20px' }}>
                    DTK values the health, safety and welfare of its staff and students and believes that the promotion of good management of health and safety is a benefit to everyone involved, including staff, students, employers, and members of the community.
                  </p>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '20px' }}>
                    DTK is committed to promoting positive attitudes to health, safety, and wellbeing to all its staff. It is the policy of DTK to protect the health, safety, and welfare at work of all staff and others affected by DTK' undertakings. DTK will comply with the Health and Safety at Work Act 1974 and other health and safety related legislation, regulations, orders, and approved codes of practice applicable to its undertakings.
                  </p>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '0' }}>
                    DTK will provide and maintain safe working conditions to ensure a healthy and safe working environment, including safe access and egress for all staff, students and visitors, adequate arrangements for the safe use, handling, storage and control of substances and maintenance of plant and equipment, so far as is reasonably practicable.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Continued Health and Safety Statement */}
        <section style={{ padding: '0 0 60px' }}>
          <div className="container" data-aos="fade-up">
            <div className="row justify-content-center">
              <div className="col-lg-10">
                <div className="p-5 shadow-lg" style={{ 
                  backgroundColor: '#fff',
                  borderRadius: '24px',
                  border: '1px solid #e2e8f0'
                }}>
                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '20px' }}>
                    DTK will ensure that hazard identification and risk assessments are carried out regularly, including workplace, fire and work-related assessments, and actions undertaken to reduce risks so far as is reasonably practicable to prevent accidents and cases of work-related ill health.
                  </p>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '20px' }}>
                    DTK will provide suitable and sufficient information, instruction, training, and supervision to ensure that all staff are competent to carry out their allocated work safely and are fully aware of their duties and responsibilities for the health, safety and welfare of themselves and others.
                  </p>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '20px' }}>
                    DTK will consult with its staff on matters affecting health and safety.
                  </p>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '0' }}>
                    This Policy will be reviewed annually and revised as is necessary to carry out DTK's responsibilities.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* 4. Roles and Responsibilities */}
        <section style={{ padding: '0 0 60px' }}>
          <div className="container" data-aos="fade-up">
            <div className="row justify-content-center">
              <div className="col-lg-10">
                <div className="p-5 shadow-lg" style={{ 
                  backgroundColor: '#fff',
                  borderRadius: '24px',
                  border: '1px solid #e2e8f0'
                }}>
                  <h3 style={{ color: '#0369a1', fontSize: '1.8rem', fontWeight: '700', marginBottom: '20px' }}>
                    4. Roles and Responsibilities
                  </h3>
                  
                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '30px' }}>
                    Directors will monitor the overall health and safety performance of DTK and compliance with health and safety legislation and ensure that decisions taken when developing policies and services reflect DTK' health and safety commitment.
                  </p>

                  <h4 style={{ color: '#7B3F9E', fontSize: '1.4rem', fontWeight: '600', marginBottom: '20px' }}>
                    Director will:
                  </h4>

                  <ul style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.8', paddingLeft: '25px' }}>
                    <li style={{ marginBottom: '12px' }}>Receive annual reports on health and safety.</li>
                    <li style={{ marginBottom: '12px' }}>Ensure that adequate resources are available to support DTK' health and safety commitments.</li>
                    <li style={{ marginBottom: '12px' }}>Consider overall health and safety trends and issues likely to affect DTK.</li>
                    <li style={{ marginBottom: '12px' }}>Promote a positive health and safety culture within DTK. The Director is the lead for health and safety matters.</li>
                    <li style={{ marginBottom: '12px' }}>Report Health and Safety matters to HSE.</li>
                    <li style={{ marginBottom: '0' }}>Report Student Health and Safety incidents to the ESFA to comply with the Reporting of Injuries Diseases and Dangerous Occurrences Regulations 2013 by submitting the relevant form to the enforcing authority.</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Health and Safety Manager Responsibilities */}
        <section style={{ padding: '0 0 60px' }}>
          <div className="container" data-aos="fade-up">
            <div className="row justify-content-center">
              <div className="col-lg-10">
                <div className="p-5 shadow-lg" style={{ 
                  backgroundColor: '#fff',
                  borderRadius: '24px',
                  border: '1px solid #e2e8f0'
                }}>
                  <h4 style={{ color: '#7B3F9E', fontSize: '1.4rem', fontWeight: '600', marginBottom: '20px' }}>
                    Health and Safety Manager will:
                  </h4>

                  <ul style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.8', paddingLeft: '25px', marginBottom: '0' }}>
                    <li style={{ marginBottom: '12px' }}>Ensure compliance with all health and safety laws.</li>
                    <li style={{ marginBottom: '12px' }}>Ensure that all statutory requirements are adhered to, and for reviewing the effectiveness of this Policy.</li>
                    <li style={{ marginBottom: '12px' }}>Set health and safety objectives and require Staff to account for effective health and safety practice in their areas of responsibility.</li>
                    <li style={{ marginBottom: '12px' }}>Ensure the provision of an annual health and safety report to the Director.</li>
                    <li style={{ marginBottom: '12px' }}>Promote a positive health and safety culture encouraging positive attitudes to health and wellbeing among all staff and students.</li>
                    <li style={{ marginBottom: '12px' }}>Ensure appropriate priority is given to health and safety in all DTK' strategic planning.</li>
                    <li style={{ marginBottom: '12px' }}>Ensure that health and safety performance is reviewed annually (and at other times when necessary).</li>
                    <li style={{ marginBottom: '12px' }}>Ensure that adequate resources are provided to meet DTK' objectives for health and safety and staff / student wellbeing.</li>
                    <li style={{ marginBottom: '12px' }}>Ensure that DTK has competent health and safety advice to meet statutory requirements.</li>
                    <li style={{ marginBottom: '12px' }}>Responsible for ensuring that adequate health and safety arrangements are in place for staff areas of responsibility and are accountable to the Director for achieving this.</li>
                    <li style={{ marginBottom: '12px' }}>Ensure the Health and Safety Policy, and health and safety guidance are followed.</li>
                    <li style={{ marginBottom: '12px' }}>Require staff to account for effective health and safety practice for all staff and students in their areas of responsibility.</li>
                    <li style={{ marginBottom: '12px' }}>Set, review, and revise the specific health and safety arrangements in their areas of responsibility to ensure the effectiveness of DTK's Policy.</li>
                    <li style={{ marginBottom: '12px' }}>Arrange staff consultation and receive reports on health and safety performance.</li>
                    <li style={{ marginBottom: '12px' }}>Establish and agree DTK's health and safety standards and targets.</li>
                    <li style={{ marginBottom: '12px' }}>Responsible for planning, measuring, and monitoring health and safety performance.</li>
                    <li style={{ marginBottom: '12px' }}>Liaise with the Management Team to ensure that training programmes make adequate provision for the development of health and safety management and skills.</li>
                    <li style={{ marginBottom: '12px' }}>Liaise with the Management Team to ensure that information, instruction, training and supervision on health and safety matters is provided for offer students appropriate to their areas of study.</li>
                    <li style={{ marginBottom: '12px' }}>Undertake a programme of health and safety training including a system of prioritised health and safety inspections of DTK workplaces, apprentice workspaces and contractors and their activities.</li>
                    <li style={{ marginBottom: '12px' }}>Liaise with enforcement agencies and other lead bodies to enable best practice in health and safety management.</li>
                    <li style={{ marginBottom: '0' }}>Provide, record, and monitor a programme of health and safety inspections throughout DTK each year and prioritises these in relation to risk.</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Continued Responsibilities - Page 5 */}
        <section style={{ padding: '0 0 60px' }}>
          <div className="container" data-aos="fade-up">
            <div className="row justify-content-center">
              <div className="col-lg-10">
                <div className="p-5 shadow-lg" style={{ 
                  backgroundColor: '#fff',
                  borderRadius: '24px',
                  border: '1px solid #e2e8f0'
                }}>
                  <ul style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.8', paddingLeft: '25px', marginBottom: '30px' }}>
                    <li style={{ marginBottom: '12px' }}>Undertake the programme of health and safety inspections covering all aspects of health and safety compliance including use of machinery, substances, trips and visits, risk assessment, working at heights, both at DTK and at Apprentices place of work.</li>
                    <li style={{ marginBottom: '12px' }}>Assist with induction, training and instructing managers and supervisors as necessary.</li>
                    <li style={{ marginBottom: '12px' }}>Receive and review all reports of accidents, incidents, dangerous occurrences and near misses from staff, students, and visitors.</li>
                    <li style={{ marginBottom: '12px' }}>Review all requests for trips and visits following the risk assessment procedures.</li>
                    <li style={{ marginBottom: '12px' }}>Investigate accidents, incidents, dangerous occurrences/near misses as required.</li>
                    <li style={{ marginBottom: '12px' }}>Liaise with contractors and partners on health and safety matters and ensure compliance.</li>
                    <li style={{ marginBottom: '12px' }}>Provide reports to the Director on accidents, incidents, dangerous occurrences/near misses, and fire safety.</li>
                    <li style={{ marginBottom: '0' }}>Arrange that the appropriate number of first aiders and fire marshals are in place as required having conducted risk assessments.</li>
                  </ul>

                  <h4 style={{ color: '#7B3F9E', fontSize: '1.4rem', fontWeight: '600', marginBottom: '20px' }}>
                    Management Team will:
                  </h4>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '20px' }}>
                    The Management Team are responsible for the health and safety of students, apprentices in their place of work, visitors and others affected by DTK activities.
                  </p>

                  <ul style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.8', paddingLeft: '25px', marginBottom: '0' }}>
                    <li style={{ marginBottom: '12px' }}>The Management Team will ensure that there are adequate arrangements for health and safety in their areas of responsibility (employees, students, and environments).</li>
                    <li style={{ marginBottom: '12px' }}>The Management Team is accountable to the Health and Safety Director as applicable for the effective implementation of the Health and Safety Policy.</li>
                    <li style={{ marginBottom: '12px' }}>Promote a positive health and safety culture in the provision of their services to students.</li>
                    <li style={{ marginBottom: '12px' }}>Implement the relevant guidance supporting the Health and Safety Policy.</li>
                    <li style={{ marginBottom: '12px' }}>Require staff who report directly to them to account for effective health and safety practice in their areas of responsibility.</li>
                    <li style={{ marginBottom: '12px' }}>Ensure that health and safety responsibilities within their remit are properly assigned and fulfilled.</li>
                    <li style={{ marginBottom: '12px' }}>Ensure all staff are aware of their day-to-day health and safety responsibilities, that staff are competent to undertake this role, and fulfil their health and safety duties.</li>
                    <li style={{ marginBottom: '12px' }}>Ensure that information, instruction, training, and supervision are provided for their staff appropriate to their role and responsibility.</li>
                    <li style={{ marginBottom: '0' }}>Ensure staff who need training for the effective management of health and safety are released for the appropriate courses.</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Management Team Continued & Staff Responsibilities */}
        <section style={{ padding: '0 0 60px' }}>
          <div className="container" data-aos="fade-up">
            <div className="row justify-content-center">
              <div className="col-lg-10">
                <div className="p-5 shadow-lg" style={{ 
                  backgroundColor: '#fff',
                  borderRadius: '24px',
                  border: '1px solid #e2e8f0'
                }}>
                  <ul style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.8', paddingLeft: '25px', marginBottom: '30px' }}>
                    <li style={{ marginBottom: '12px' }}>Ensure that information, instruction, training and supervision on health and safety matters is provided for their students appropriate to their area of study.</li>
                    <li style={{ marginBottom: '12px' }}>Participate in evaluating risks and reviewing health and safety performance.</li>
                    <li style={{ marginBottom: '12px' }}>Ensure that contractors they commission to undertake work for DTK have suitable standards and arrangements for health and safety, and the contract is managed appropriately to make sure the work is done safely.</li>
                    <li style={{ marginBottom: '12px' }}>Support staff, if it is necessary to suspend activities and services (including those provided by DTK contractors) where there is imminent risk of serious injury or ill health to staff or others.</li>
                    <li style={{ marginBottom: '12px' }}>Ensure that the risks from hazardous activities are assessed and controls are implemented to control those risks, including risks to DTK employees who work from home or at workplaces under the control of other organisations.</li>
                    <li style={{ marginBottom: '12px' }}>Ensure health and safety induction takes places for all new employees.</li>
                    <li style={{ marginBottom: '0' }}>During a pandemic, follow NHS/Government guidelines. For further details, please refer to our Covid-19 Prevention Policy.</li>
                  </ul>

                  <h4 style={{ color: '#7B3F9E', fontSize: '1.4rem', fontWeight: '600', marginBottom: '20px' }}>
                    Staff will:
                  </h4>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '20px' }}>
                    All staff will be responsible for the implementation of DTK's health and safety arrangements for student activities under their control and they are accountable to their line manager for achieving this. DTK expects its staff to look after their health, and to take reasonable care for the health, safety and welfare of themselves and students' and of others who may be affected by their actions. All staff are accountable to his/her line manager for achieving this.
                  </p>

                  <h4 style={{ color: '#7B3F9E', fontSize: '1.4rem', fontWeight: '600', marginBottom: '20px' }}>
                    Staff must:
                  </h4>

                  <ul style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.8', paddingLeft: '25px', marginBottom: '0' }}>
                    <li style={{ marginBottom: '12px' }}>Promote a positive health and safety culture, encouraging health promoting activities and requiring consideration of health and wellbeing for all in the provision of their services.</li>
                    <li style={{ marginBottom: '12px' }}>Report to the relevant manager all accidents and illnesses that have been referred to them by students or staff. They may seek assistance from the Health and Safety Manager where necessary.</li>
                    <li style={{ marginBottom: '12px' }}>In circumstances where a remedial action is beyond the resources of the line manager or supervisor, or where it is not accepted by the employee or their representatives, the matter must be referred to their line manager.</li>
                    <li style={{ marginBottom: '0' }}>Ensure information, instruction, training and supervision on health and safety matters is provided for their students appropriate to their area of study.</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Staff Must - Page 7 */}
        <section style={{ padding: '0 0 60px' }}>
          <div className="container" data-aos="fade-up">
            <div className="row justify-content-center">
              <div className="col-lg-10">
                <div className="p-5 shadow-lg" style={{ 
                  backgroundColor: '#fff',
                  borderRadius: '24px',
                  border: '1px solid #e2e8f0'
                }}>
                  <ul style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.8', paddingLeft: '25px', marginBottom: '0' }}>
                    <li style={{ marginBottom: '12px' }}>Ensure health and safety induction takes place for all new students.</li>
                    <li style={{ marginBottom: '12px' }}>Ensure regular inspections are carried out in buildings and working environments.</li>
                    <li style={{ marginBottom: '12px' }}>Ensure that all work equipment is maintained in safe condition and checked at appropriate intervals by competent persons.</li>
                    <li style={{ marginBottom: '12px' }}>Report and record accidents and incidents, dangerous occurrences/near misses.</li>
                    <li style={{ marginBottom: '12px' }}>Remedy any unsafe situation within their competence or report such to their line manager or supervisors in the first instance, who will ensure that the appropriate action is taken.</li>
                    <li style={{ marginBottom: '12px' }}>Not misuse or interfere with anything that is provided for health and safety.</li>
                    <li style={{ marginBottom: '0' }}>Use machinery, equipment, substances, and any safety device according to their training or instruction, and in compliance with the law.</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* 5. Consultation with Unions & 6. Arrangements */}
        <section style={{ padding: '0 0 60px' }}>
          <div className="container" data-aos="fade-up">
            <div className="row justify-content-center">
              <div className="col-lg-10">
                <div className="p-5 shadow-lg mb-4" style={{ 
                  backgroundColor: '#fff',
                  borderRadius: '24px',
                  border: '1px solid #e2e8f0'
                }}>
                  <h3 style={{ color: '#0369a1', fontSize: '1.8rem', fontWeight: '700', marginBottom: '20px' }}>
                    5. Consultation with Unions, Staff and Student Representatives
                  </h3>
                  
                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '0' }}>
                    DTK has a duty to consult with Unions and staff on any matters that affect health, safety, and welfare at work. This consultation will be conducted by the Health and Safety Director. Students are consulted with through their academic area and the relevant student forum.
                  </p>
                </div>

                <div className="p-5 shadow-lg" style={{ 
                  backgroundColor: '#fff',
                  borderRadius: '24px',
                  border: '1px solid #e2e8f0'
                }}>
                  <h3 style={{ color: '#0369a1', fontSize: '1.8rem', fontWeight: '700', marginBottom: '20px' }}>
                    6. Arrangements
                  </h3>
                  
                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '0' }}>
                    DTK' arrangements for ensuring the implementation of good health and safety practice are contained in this Policy and the associated guidance. This Guidance outlines important health and safety matters and actions that staff must take.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* 7. Accident and Incident Reporting */}
        <section style={{ padding: '0 0 60px' }}>
          <div className="container" data-aos="fade-up">
            <div className="row justify-content-center">
              <div className="col-lg-10">
                <div className="p-5 shadow-lg" style={{ 
                  backgroundColor: '#fff',
                  borderRadius: '24px',
                  border: '1px solid #e2e8f0'
                }}>
                  <h3 style={{ color: '#0369a1', fontSize: '1.8rem', fontWeight: '700', marginBottom: '20px' }}>
                    7. Accident and Incident Reporting
                  </h3>
                  
                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '20px' }}>
                    Accident reporting is covered by the Reporting of Injuries, Diseases and Dangerous Occurrences Regulations 2013 (RIDDOR). Whilst the overall aim must be to reduce accidents and occupational ill-health to a minimum, it is important to establish the number and type of accidents, incidents and near misses occurring within DTK area of responsibility and to ensure that those which require reporting to the Statutory Authority are correctly reported.
                  </p>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '0' }}>
                    It is the responsibility of all employees to ensure that all accidents, incidents occupational ill-health and dangerous occurrences/near misses are reported to the Health and Safety Director. Those incidents requiring reporting to the Health and Safety Executive under RIDDOR must be reported by the Health and Safety Director so that the statutory report can be made. Such reports are only to be made by the Health and Safety Director and will require investigation in line with procedures. Those incidents requiring reporting under RIDDOR are identified at the following link.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Page 8 - Continued Sections */}
        <section style={{ padding: '0 0 60px' }}>
          <div className="container" data-aos="fade-up">
            <div className="row justify-content-center">
              <div className="col-lg-10">
                <div className="p-5 shadow-lg" style={{ 
                  backgroundColor: '#fff',
                  borderRadius: '24px',
                  border: '1px solid #e2e8f0'
                }}>
                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '20px' }}>
                    <a href="http://www.hse.gov.uk/riddor/reportable-incidents.htm" target="_blank" rel="noopener noreferrer" style={{ color: '#0369a1', textDecoration: 'underline' }}>
                      http://www.hse.gov.uk/riddor/reportable-incidents.htm
                    </a>
                  </p>

                  <h4 style={{ color: '#7B3F9E', fontSize: '1.4rem', fontWeight: '600', marginBottom: '20px' }}>
                    Accident and Incident Investigation
                  </h4>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '30px' }}>
                    The Health and Safety Director will liaise with staff on the investigation of accidents and incidents. This is to ensure that trends are identified, and procedures put in place to avoid a recurrence wherever possible.
                  </p>

                  <h4 style={{ color: '#7B3F9E', fontSize: '1.4rem', fontWeight: '600', marginBottom: '20px' }}>
                    First Aid and Fire Marshalls
                  </h4>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '30px' }}>
                    The Health and Safety Director arranges that the appropriate number of first aiders and fire marshals are in place as required having conducted risk assessments of the areas of activity of DTK.
                  </p>

                  <h4 style={{ color: '#7B3F9E', fontSize: '1.4rem', fontWeight: '600', marginBottom: '20px' }}>
                    Risk Assessments
                  </h4>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '20px' }}>
                    Risk assessment is central to the management of health and safety. By identifying hazards within the workplace, risks can be judged, and suitable measures put in place to eliminate or, when this is not possible, to control those risks, thus ensuring a safe working and learning environments for all. Risk assessments are required for all work activities for both staff and students proportionate to the degree of risk, and specific risks assessments are required in certain circumstances, for example Manual Handling, Use of Display Screen Equipment, Control of Substances Hazardous to Health, etc.
                  </p>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '30px' }}>
                    Risk assessments must be completed by the Health and Safety Director.
                  </p>

                  <h4 style={{ color: '#7B3F9E', fontSize: '1.4rem', fontWeight: '600', marginBottom: '20px' }}>
                    Violence to Staff
                  </h4>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '30px' }}>
                    No employee or worker should be faced with violence in the workplace either from fellow employees or from students or members of the public. Risk assessment must be carried out to identify the likelihood of violence and suitable control measures introduced, for example conflict avoidance training and classroom behaviour management.
                  </p>

                  <h4 style={{ color: '#7B3F9E', fontSize: '1.4rem', fontWeight: '600', marginBottom: '20px' }}>
                    Work with Display Screen Equipment (DSE)
                  </h4>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '0' }}>
                    Whilst line managers have the responsibility to ensure that suitable risk assessments have been undertaken, employees need to take personal responsibility for ensuring that their workstation is setup correctly and that breaks to other tasks away from the screen are included in their
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Page 9 - Work Equipment, PPE, Hazardous Substances, Manual Handling */}
        <section style={{ padding: '0 0 60px' }}>
          <div className="container" data-aos="fade-up">
            <div className="row justify-content-center">
              <div className="col-lg-10">
                <div className="p-5 shadow-lg" style={{ 
                  backgroundColor: '#fff',
                  borderRadius: '24px',
                  border: '1px solid #e2e8f0'
                }}>
                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '20px' }}>
                    normal working day. Guidance on Use of Display Screen Equipment can be found at the following link: <a href="http://www.hse.gov.uk/pubns/indg36.pdf" target="_blank" rel="noopener noreferrer" style={{ color: '#0369a1', textDecoration: 'underline' }}>http://www.hse.gov.uk/pubns/indg36.pdf</a>
                  </p>

                  <h4 style={{ color: '#7B3F9E', fontSize: '1.4rem', fontWeight: '600', marginBottom: '20px' }}>
                    Provision and use of work equipment
                  </h4>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '30px' }}>
                    Any equipment provided for the use of employees and students must be suitable for its purpose and safe to use. This includes equipment such as lifting equipment e.g., hoist or equipment used in academic areas such as Health and Social Care or IT. Training on the use of such equipment must be provided to the relevant standard and competency established before an individual is allowed to use that equipment. This is reviewed every 3 months.
                  </p>

                  <h4 style={{ color: '#7B3F9E', fontSize: '1.4rem', fontWeight: '600', marginBottom: '20px' }}>
                    Personal Protective Equipment (PPE)
                  </h4>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '30px' }}>
                    If PPE is identified through risk assessment as being required. It must always be considered as a last resort providing protection to employees or students against risk. Other means of providing proper protection should be considered first, such that the risk is addressed at source i.e. removed from the work environment rather than controlled on an individual basis, leaving the risk still present in the workplace. Suitable training and information in the use PPE and its storage and care will be given to employees or students where PPE is issued. Records of the issue of PPE must always be maintained.
                  </p>

                  <h4 style={{ color: '#7B3F9E', fontSize: '1.4rem', fontWeight: '600', marginBottom: '20px' }}>
                    Control of Hazardous Substances
                  </h4>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '20px' }}>
                    The use of hazardous substances is covered by the Control of Substances Hazardous to Health Regulations 2002 (as amended) (COSHH). Where items that are flammable are used the Dangerous Substances and Explosive Atmosphere Regulations 2002 (DSEAR) additionally apply. Risk assessments are required for the use of hazardous substances such as cleaning materials, scientific and art materials, workshop substances e.g. glue etc. Guidance on Control of Substances Hazardous to Health, etc (COSHH) can be found at the following link.
                  </p>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '30px' }}>
                    <a href="http://www.hse.gov.uk/pubns/indg136.pdf" target="_blank" rel="noopener noreferrer" style={{ color: '#0369a1', textDecoration: 'underline' }}>
                      http://www.hse.gov.uk/pubns/indg136.pdf
                    </a>
                  </p>

                  <h4 style={{ color: '#7B3F9E', fontSize: '1.4rem', fontWeight: '600', marginBottom: '20px' }}>
                    Manual Handling
                  </h4>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '20px' }}>
                    Manual handling is covered by the Manual Handling Operations Regulations 1992 (as amended) MHOR. Specific risk assessments are required for any task involving manual handling and Guidance on Manual Handling can be found on at the following link.
                  </p>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '0' }}>
                    <a href="http://www.hse.gov.uk/pubns/indg143.pdf" target="_blank" rel="noopener noreferrer" style={{ color: '#0369a1', textDecoration: 'underline' }}>
                      http://www.hse.gov.uk/pubns/indg143.pdf
                    </a>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Page 10 - Electrical Safety, Fire Safety, Workplace Requirements, Trips and Visits */}
        <section style={{ padding: '0 0 60px' }}>
          <div className="container" data-aos="fade-up">
            <div className="row justify-content-center">
              <div className="col-lg-10">
                <div className="p-5 shadow-lg" style={{ 
                  backgroundColor: '#fff',
                  borderRadius: '24px',
                  border: '1px solid #e2e8f0'
                }}>
                  <h4 style={{ color: '#7B3F9E', fontSize: '1.4rem', fontWeight: '600', marginBottom: '20px' }}>
                    Electrical safety
                  </h4>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '20px' }}>
                    Electricity is a familiar and necessary part of everyday life, but electricity can severely injure or even kill people and cause damage to property. Guidance on electrical safety and the requirement for regular testing of appliances can be found at the following link.
                  </p>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '30px' }}>
                    <a href="http://www.hse.gov.uk/Toolbox/electrical.htm" target="_blank" rel="noopener noreferrer" style={{ color: '#0369a1', textDecoration: 'underline' }}>
                      http://www.hse.gov.uk/Toolbox/electrical.htm
                    </a>
                  </p>

                  <h4 style={{ color: '#7B3F9E', fontSize: '1.4rem', fontWeight: '600', marginBottom: '20px' }}>
                    Fire safety
                  </h4>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '30px' }}>
                    Fire is probably the foremost risk to both persons and property. By conducting a specific fire risk assessment and implementing the control measures identified, the risk can be reduced to an acceptable level. Staff and students must be trained in evacuation procedures and practice evacuations must be held at least termly.
                  </p>

                  <h4 style={{ color: '#7B3F9E', fontSize: '1.4rem', fontWeight: '600', marginBottom: '20px' }}>
                    Workplace requirements
                  </h4>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '20px' }}>
                    General advice on the Workplace health, safety, and welfare (e.g. environment, trip hazards, spills) which must be applied throughout the College, can be found at the following link.
                  </p>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '30px' }}>
                    <a href="http://www.hse.gov.uk/pubns/priced/l24.pdf" target="_blank" rel="noopener noreferrer" style={{ color: '#0369a1', textDecoration: 'underline' }}>
                      http://www.hse.gov.uk/pubns/priced/l24.pdf
                    </a>
                  </p>

                  <h4 style={{ color: '#7B3F9E', fontSize: '1.4rem', fontWeight: '600', marginBottom: '20px' }}>
                    Trips and Visits <span style={{ fontWeight: '400', fontStyle: 'italic' }}>(including residential visits)</span>
                  </h4>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '0' }}>
                    DTK takes the health, safety and welfare of its students and staff very seriously and the required risk assessment process must have been followed in advance of any trip or visit taking place, including providing details to parents or guardians for relevant students and obtaining consent.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* 8. Communication of the Health and Safety Policy */}
        <section style={{ padding: '0 0 80px' }}>
          <div className="container" data-aos="fade-up">
            <div className="row justify-content-center">
              <div className="col-lg-10">
                <div className="p-5 shadow-lg" style={{ 
                  backgroundColor: '#fff',
                  borderRadius: '24px',
                  border: '1px solid #e2e8f0'
                }}>
                  <h3 style={{ color: '#0369a1', fontSize: '1.8rem', fontWeight: '700', marginBottom: '20px' }}>
                    8. COMMUNICATION OF THE HEALTH AND SAFETY POLICY
                  </h3>

                  <h4 style={{ color: '#7B3F9E', fontSize: '1.4rem', fontWeight: '600', marginBottom: '20px' }}>
                    Communication Arrangements
                  </h4>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '20px' }}>
                    Copies of the Health and Safety Policy are circulated to all employees, employers and students on its revision and commencement.
                  </p>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '20px' }}>
                    Each Staff member undertakes annual Health and Safety Training. This is reviewed in their monthly supervision meetings.
                  </p>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '20px' }}>
                    A copy of the Health and Safety Policy is held on the DTK website <a href="http://www.dtkcollege.co.uk/" target="_blank" rel="noopener noreferrer" style={{ color: '#0369a1', textDecoration: 'underline' }}>http://www.dtkcollege.co.uk/</a>
                  </p>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '20px' }}>
                    A copy of the Health and Safety Policy is included in the Student Handbook which is given to all students on induction.
                  </p>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '20px' }}>
                    The <em>Be Safe at work</em> booklet is issued to all students at induction.
                  </p>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '20px' }}>
                    Apprenticeship workplace Health and Safety is monitored by Employer Risk assessments and student workplace health and safety inductions.
                  </p>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '20px' }}>
                    Apprentice Health and Safety is reviewed every 8-12 weeks at their progress review with their assessor/manager.
                  </p>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '20px' }}>
                    Those staff with a particular role to play, for example conducting risk assessments, fire marshals, first aiders, will receive additional specific training.
                  </p>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '0' }}>
                    Training requirements are identified between staff, employers, students, line managers, and senior managers and the Health and Safety Director.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}

export default HealthSafetyPolicy;